module.exports = __webpack_public_path__ + "static/Tango-1-d60b991eb06a1493317b234da036429d.jpg";